import { render, staticRenderFns } from "./InternalDocForm.vue?vue&type=template&id=8d526118"
import script from "./InternalDocForm.vue?vue&type=script&lang=js"
export * from "./InternalDocForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports